import React, { useEffect, useState, useMemo } from "react";


import AddLabPanel from "./EmployeeVisitDetailView/RightContent/ActivityChart/ChartsFields/AddLabPanel";
import { getLookupByKey } from "../../utils/commonUtils";
import Buttons from "../../components/UI/Buttons";
import SectionLoader from "../../components/UI/SectionLoader";
import TableGrid from "../../components/UI/TableGrid";
import WithRoutify from "../../hoc/WithRoutify";
import LabOrderdService from "../../services/LabOrderdService";
import { data } from "jquery";

const LabPanelCopy = (props) => {
    const { Toast, Loader,fetchRecords, childLab} = props;   
    const parent_id=props.formData.id;
    const [panelList, setPanelList] = useState({ tableHeaders: [], tableRows: { data: [] } });
    const [isLoading, setLoaded] = useState(false);
    const [validation, setValidation] = useState({});
    const [laborderOptions, setLabOrderOptions] = useState([]);
    const [formData, setFormData] = useState([]);
    const [isModalOpen,setModalToogle]  = useState(false);
    const [selectedConfig, setSelectedConfig] = useState(null);
    const [inputFields, setInputFields] = useState([]);
    useEffect(() => {
        fetchLabOrder();        
    }, []);
    useEffect(() => {
        if (parent_id) {
            fetchPanelList();
        }
    }, [parent_id]);
    const fetchLabOrder = async () => {
        // await props.fetchLabOrderList(null, null, (res) => {
        //     res.unshift({label:"-Select-",value:''})
        //     setLabOrderOptions(res);
        // });
        const response=await getLookupByKey('child_laborder');
        setLabOrderOptions(response);
    }
    const fetchPanelList = async () => {
       
    }
    const getTableHeaders = () => [
        { label: 'Lab Ordered', key: 'lab_order', type: '' },
        { label: 'Result', key: 'result', type: '' },
        { label: 'Reference Range', key: 'reference_range', type: '' },
        { label: 'Units', key: 'units', type: '' },
        { label: 'Flag', key: 'flag', type: '' },
        { label: 'Lab Message', key: 'lab_message', type: '' },
        { label: 'Action', key: 'action', type: 'Actions' },
        // Add more columns as needed
    ];
    // Initialize panelList with childLab data when it's available
    useEffect(() => {
        if (childLab && childLab.length > 0) {
            // Add actions to each item if they don't have them
            const childLabWithActions = childLab.map((item) => {
                if (!item.data.action || item.data.action.length === 0) {
                    return {
                        ...item,
                        data: {
                            ...item.data,
                            action: [
                                {
                                    className: "btn btn-icon btn-transparent-dark",
                                    iconType: "Edit",
                                    title: "Edit",
                                    acl: "company-edit",
                                    clickHandler: (id, itemData) => editHandler(id, item)
                                },
                                {
                                    className: 'btn btn-icon btn-transparent-dark',
                                    iconType: 'Remove',
                                    acl: 'any',
                                    title: 'Delete',
                                    isDelete: true,
                                    clickHandler: (id, itemData) => deleteHandl(id, item),
                                }
                            ]
                        }
                    };
                }
                return item;
            });
            setPanelList({
                tableHeaders: getTableHeaders(),
                tableRows: { data: childLabWithActions }
            });
        } else if (childLab && childLab.length === 0) {
            // Clear the table if childLab is empty
            setPanelList({
                tableHeaders: getTableHeaders(),
                tableRows: { data: [] }
            });
        }
    }, [childLab]);

    const getRowActions = (item) => [
        {
            className: "btn btn-icon btn-transparent-dark",
            iconType: "Edit",
            title: "Edit",
            acl: "company-edit",
            clickHandler: (id, itemData) => editHandler(id, item)
        },
        {
            className: 'btn btn-icon btn-transparent-dark',
            iconType: 'Remove',
            acl: 'any',
            title: 'Delete',
            isDelete: true,
            clickHandler: (id) => deleteHandl(id, item),
        }
    ];

    const submiHandler = () => {
        if (formData.id) {
            const newdata = panelList.tableRows.data.map((item) => {
                if (item.rowId === formData.id) {
                    const updatedItem = {
                        ...item,
                        data: {
                            lab_order: formData.lab_order || '',
                            result: formData.result || '',
                            reference_range: formData.reference_range || '',
                            units: formData.units || '',
                            flag: formData.flag || '',
                            lab_message: formData.lab_message || '',
                            id: item.data?.id
                        },
                    };
                    updatedItem.data.action = getRowActions(updatedItem);
                    return updatedItem;
                }
                return item;
            });
            setPanelList({ tableHeaders: getTableHeaders(), tableRows: { data: newdata } });
            props.setChildLab(newdata);
        } else {
            const id = Math.floor(100000 + Math.random() * 900000);
            const newItem = {
                rowId: id,
                data: {
                    lab_order: formData.lab_order || '',
                    result: formData.result || '',
                    reference_range: formData.reference_range || '',
                    units: formData.units || '',
                    flag: formData.flag || '',
                    lab_message: formData.lab_message || '',
                    action: getRowActions({ rowId: id, data: {} })
                }
            };
            newItem.data.action = getRowActions(newItem);
            const tabledata = [...panelList.tableRows.data, newItem];
            setPanelList({ tableHeaders: getTableHeaders(), tableRows: { data: tabledata } });
            props.setChildLab(tabledata);
        }
        setModalToogle(false);
        setFormData({});
        setValidation({});
    };
 const deleteHandl = (id, item) => {
        // Extract the id - could be from parameter, item.rowId, or item.data.id
        const deleteId = id || item?.rowId || item?.data?.id || item?.data?.rowId || null;
        
        console.log('deleteHandl - ID extraction:', {
            idParam: id,
            itemRowId: item?.rowId,
            itemDataId: item?.data?.id,
            itemDataRowId: item?.data?.rowId,
            finalId: deleteId
        });
        
        if (!deleteId) {
            console.error('deleteHandl - No valid ID found for deletion');
            return;
        }
        
        setPanelList(prev => {
            const newData = prev.tableRows.data.filter(item => {
                // Check both rowId and data.id to handle different structures
                const itemId = item.rowId || item.data?.id || item.data?.rowId;
                return itemId !== deleteId;
            });
            props.setChildLab(newData);
            return {
                ...prev,
                tableRows: { data: newData }
            };
        });
    }
    const editHandler = async (id, item) => {
        setValidation({});
        const itemData = item?.data || item || {};
        const editId = id || item?.rowId || itemData.id || itemData.rowId || null;
        const labOrderName = itemData.lab_order || '';
        
        // Set form data first
        setFormData({
            id: editId,
            lab_order: labOrderName,
            result: itemData.result || '',
            reference_range: itemData.reference_range || '',
            units: itemData.units || '',
            flag: itemData.flag || '',
            lab_message: itemData.lab_message || ''
        });
        
        // Fetch configuration for this lab order
        const labId = props.formData.lab_id;
        const labOrderId = props.formData.lab_order_id;
        
        if (labId && labOrderId && labOrderName) {
            try {
                const configs = await LabOrderdService.getChildLabOrderConfigurations(
                    null, labId, labOrderId
                );
                
                // Find the configuration that matches the lab_order name
                const matchingConfig = configs?.find(config => config.lab_order === labOrderName);
                
                if (matchingConfig) {
                    setSelectedConfig(matchingConfig);
                    // Build input fields based on configuration - use current laborderOptions
                    const fields = buildInputFieldsFromConfig(matchingConfig, laborderOptions);
                    setInputFields(fields);
                } else {
                    // No matching config, use default fields - use current laborderOptions
                    setSelectedConfig(null);
                    setInputFields(getDefaultInputFields(laborderOptions));
                }
            } catch (error) {
                console.error('Error fetching configuration:', error);
                setSelectedConfig(null);
                setInputFields(getDefaultInputFields(laborderOptions));
            }
        } else {
            setSelectedConfig(null);
            setInputFields(getDefaultInputFields(laborderOptions));
        }
        
        setModalToogle(true);
    };
    
    // Default simple string fields
    const getDefaultInputFields = (options = laborderOptions) => [
        {
            type: "SelectList",
            options: options,
            label: 'Lab Order',
            name: 'lab_order',
            placeholder: 'Lab Order',
            required: true,
        },
        { type: 'TextInput', label: 'Result', name: 'result', placeholder: 'Result' },
        { type: 'TextInput', label: 'Reference Range', name: 'reference_range', placeholder: 'Reference Range', disabled: true },
        { type: 'TextInput', label: 'Units', name: 'units', placeholder: 'Units' },
        { type: 'TextInput', label: 'Flag', name: 'flag', placeholder: 'Flag' },
        { type: 'TextArea', label: 'Lab Message', name: 'lab_message', placeholder: 'Lab Message' },
    ];
    
    // Helper function to build a field based on its type
    const buildFieldByType = (name, label, dataType, dataValue) => {
        const options = Array.isArray(dataValue.options) ? dataValue.options : [];
        
        // Reference Range is always disabled/read-only
        const isDisabled = name === 'reference_range';
        
        switch (dataType) {
            case 'dropdown':
                const dropdownOptions = [
                    { label: '-Select-', value: '' },
                    ...options.map(opt => ({ label: opt, value: opt }))
                ];
                return {
                    type: 'SelectList',
                    options: dropdownOptions,
                    label: label,
                    name: name,
                    placeholder: label,
                    disabled: isDisabled,
                };
            case 'radio':
                const radioOptions = options.map(opt => ({ label: opt, value: opt }));
                return {
                    type: 'RadioGroup',
                    options: radioOptions,
                    label: label,
                    name: name, 
                    placeholder: label,
                    disabled: isDisabled,
                };
            case 'checkbox':
                const checkboxOptions = options.map(opt => ({ label: opt, value: opt }));
                return {
                    type: 'Checkbox',
                    options: checkboxOptions,
                    label: label,
                    name: name,
                    placeholder: label,
                    disabled: isDisabled,
                };
            case 'textarea':
                return {
                    type: 'TextArea',
                    label: label,
                    name: name,
                    placeholder: label,
                    disabled: isDisabled,
                };
            case 'number':
                return {
                    type: 'TextInput',
                    label: label,
                    name: name,
                    placeholder: label,
                    disabled: isDisabled,
                    isNumeric: true, // Restrict input to numbers only
                };
            case 'textinput':
            case 'reference_range': // Handle reference_range type as textinput for now
            default:
                return {
                    type: 'TextInput',
                    label: label,
                    name: name,
                    placeholder: label,
                    disabled: isDisabled,
                };
        }
    };
    
    // Build input fields from configuration
    const buildInputFieldsFromConfig = (config, options = laborderOptions) => {
        const fields = [
            {
                type: "SelectList",
                options: options,
                label: 'Lab Order',
                name: 'lab_order',
                placeholder: 'Lab Order',
                required: true,
            }
        ];
        
        // Helper to extract data value
        const getDataValue = (fieldPrefix) => {
            const dataValueKey = `${fieldPrefix}_data_value`;
            return config[dataValueKey] || {};
        };
        
        // Result field
        const resultDataType = config.result_data_type || 'textinput';
        const resultData = getDataValue('result');
        fields.push(buildFieldByType('result', 'Result', resultDataType, resultData));
        
        // Reference Range field
        const refRangeDataType = config.reference_range_data_type || 'textinput';
        const refRangeData = getDataValue('reference_range');
        fields.push(buildFieldByType('reference_range', 'Reference Range', refRangeDataType, refRangeData));
        
        // Units field
        const unitsDataType = config.units_data_type || 'textinput';
        const unitsData = getDataValue('units');
        fields.push(buildFieldByType('units', 'Units', unitsDataType, unitsData));
        
        // Flag field
        const flagDataType = config.flag_data_type || 'textinput';
        const flagData = getDataValue('flag');
        fields.push(buildFieldByType('flag', 'Flag', flagDataType, flagData));
        
        // Lab Message field
        const labMessageDataType = config.lab_message_data_type || 'textarea';
        const labMessageData = getDataValue('lab_message');
        fields.push(buildFieldByType('lab_message', 'Lab Message', labMessageDataType, labMessageData));
        
        return fields;
    };
    
    // Update inputFields when laborderOptions loads and modal is open
    useEffect(() => {
        if (laborderOptions.length > 0 && isModalOpen && inputFields.length > 0) {
            // Update the lab_order field options in existing inputFields
            const updatedFields = inputFields.map(field => {
                if (field.name === 'lab_order' && field.type === 'SelectList') {
                    return {
                        ...field,
                        options: laborderOptions
                    };
                }
                return field;
            });
            setInputFields(updatedFields);
        } else if (laborderOptions.length > 0 && inputFields.length === 0) {
            // Initialize if fields are empty
            setInputFields(getDefaultInputFields(laborderOptions));
        }
    }, [laborderOptions.length, isModalOpen]);
    const changeHandler = (fieldName, value, e) => {
        setFormData({ ...formData, [fieldName]: value });
        setValidation({ ...validation, [fieldName]: '' });
    }

    return (
        <>
        {isModalOpen===true &&
            <AddLabPanel 
                formData={formData}
                validation={validation}
                changeHandler={changeHandler}
                inputFields={inputFields}
                submiHandler={submiHandler} 
                toogleHandler={()=>{
                    setModalToogle(false);
                    setFormData({});
                    setSelectedConfig(null);
                    setInputFields(getDefaultInputFields(laborderOptions));
                }} />
        }
        
        <div className="sh_innerPortview">
            <div className="row">
                {/* <div className="col-12 col-lg-4">
                    <div className="sh_cardBox h-auto shadow-none border">
                        <div className="sh_cardBody p-3">
                            {
                                inputFields.map((itm, ind) => {
                                    return (
                                        <>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group mb-1">
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <label className="text-sm text-truncate mb-0 opacity-75">{itm.label}</label></div>
                                                            <div className="col-12">
                                                                <FormInputs
                                                                    changeHandler={(value, e) => changeHandler(itm.name, value, e)}
                                                                    value={formData[itm.name]}
                                                                    {...itm}
                                                                />
                                                                {isSet(validation[itm.name], '') !== '' ? <span className="text-danger m-1">
                                                                    {isSet(validation[itm.name], '')}</span> : ''}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                        </>
                                    )
                                })
                            }

                        </div>
                        <div className="sh_cardFooter justify-content-center">
                            <button className="btn btn-primary btn-sm text-sm" onClick={submiHandler}> {formData.id ? 'Update' : 'Add'} </button>
                        </div>
                    </div>
                </div> */}
                <div className="col-12 col-lg-12">

                    <div className="sh_cardBox h-auto sh_labpanelht shadow-none border">
                        <div className="sh_cardHeader">
                            <div className="form-group d-flex mb-0 justify-content-between align-items-center">
                                <h6 className="text-md mb-0">Lab Panel List </h6>
                                <div className="addAction d-flex justify-content-between align-items-center">
                                    <Buttons
                                        title={"Add Lab Panel"}
                                        className="btn btn-icon btn-transparent-dark mr-2"
                                        acl={"any"}
                                        iconType={"AddIconDetailView"}
                                        clickHandler={()=>{
                                            setFormData({});
                                            setSelectedConfig(null);
                                            setInputFields(getDefaultInputFields(laborderOptions));
                                            setModalToogle(true);
                                            setValidation({});
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="sh_cardBody p-0">
                            <SectionLoader isLoading={isLoading} />
                            <TableGrid {...panelList} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}
LabPanelCopy.defaultProps={
    fetchRecords:()=>{}
}

export default WithRoutify(LabPanelCopy);
